<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>

const userStore = useUserStore();
let showUnauthenticatedMessage = ref(false);

const { $enableShortcuts } = useNuxtApp();

function failModalDismiss() {
  showUnauthenticatedMessage.value = false;
  userStore.setAuthenticationLogout(false);
}

// watch(() => userStore.authenticationLogout, (value: boolean) => {
//   console.log("fail message", value)
//   showUnauthenticatedMessage = value;
// })

onMounted(() => {
  if (userStore.authenticationLogout === true) {
    showUnauthenticatedMessage.value = true; 
  }
  $enableShortcuts("f1", "f2");
})


</script>

